/** The desktop tells listeners when the health changes; nothing here changes, so there is nothing to undo. */
const unsubscribe = (): (() => void) => () => undefined;

/**
 * The desktop measured the computer it ran on; Paige runs Cortexa on its own hardware. The one
 * question that still varies is whether the AI reviewer can run (Autopilot): the cell has a
 * reasoner or it has not, and the engine says which.
 */
export function browserWorkstation(
  call: (command: string) => Promise<unknown>,
): Record<string, unknown> {
  const summary = 'Paige reads on its own hardware.';
  return {
    getWorkstationHealth: async () => {
      const aiReview = (await call('ai-review-available').catch(() => false)) === true;
      return {
        checkedAt: new Date().toISOString(),
        engineVersion: 'paige',
        verdict: 'verified-gpu',
        summary,
        components: [],
        diagnostic: summary,
        enhancedOcrSupported: true,
        aiReviewSupported: aiReview,
        aiReviewerInstalled: aiReview,
      };
    },
    onWorkstationHealthChanged: unsubscribe,
  };
}
